import { collectComponents } from '../utils/collectComponents';
import Accordion from './Accordion';
import AccordionButton from './Accordion/AccordionButton';
import AccordionContent from './Accordion/AccordionContent';
import AnchorTarget from './Anchor/AnchorTarget';
import Block from './Block';
import Carousel from './Carousel';
import Countdown from './Countdown';
import Coupon from './Coupon';
import Grid from './Grid';
import HTMLTemplate from './HTMLTemplate';
import Image from './Image';
import ImageMapBraze from './Image/ImageMapBraze';
import ImageMapLink from './Image/ImageMapLink';
import ImageMapShare from './Image/ImageMapShare';
import Link from './Link';
import Lottie from './Lottie';
import Page from './Page';
import ProductList from './ProductList';
import Raffle from './Raffle';
import StickyTab from './StickyTab';
import StickyTabItem from './StickyTab/StickyTabItem';
import TextTabItem from './StickyTab/TextTabItem';
import Tab from './Tab';
import TabButton from './Tab/TabButton';
import TabContent from './Tab/TabContent';
import TabItem from './Tab/TabItem';
import Text from './Text';
import Video from './Video';

export const defaultComponents = collectComponents([
  Page,
  Block,
  Grid,
  Text,
  Image,
  ImageMapLink,
  ImageMapShare,
  ImageMapBraze,
  Video,
  Link,
  Coupon,
  Raffle,
  ProductList,
  Tab,
  TabItem,
  TabButton,
  TabContent,
  AnchorTarget,
  Carousel,
  Accordion,
  AccordionButton,
  AccordionContent,
  Lottie,
  Countdown,
  HTMLTemplate,
  StickyTab,
  StickyTabItem,
  TextTabItem,
]);
